import { ConfigResponse, DEFAULT_CONFIG } from '@/@core/models/api/configResponse';
import { ASSISTANT_SERVICE } from '@/@core/services/api/AssistantService';
import {
  HTTP_CLIENT,
  EXTERNAL_REQUEST_HTTP_CLIENT,
  HTTP_CLIENT_NLS,
} from '@/@core/services/api/httpClient';
import { applyCustomColors } from '@/@core/utils/applyCustomColors';
import { applyCustomFontSettings } from '@/@core/utils/applyCustomFontSettings';
import { t, setLocalMessages } from '@/i18n';
import { createStoreId } from '@/stores/createStoreId';
import { useNotificationStore } from '@/stores/useNotificationStore';
import { defineStore } from 'pinia';
import { ref } from 'vue';

setLocalMessages('config', 'common');
setLocalMessages('notifications');

export const useConfigStore = defineStore(
  createStoreId('config'),
  () => {
    const config = ref<ConfigResponse>(DEFAULT_CONFIG);
    const { addErrorNotification } = useNotificationStore();

    const getConfig: () => Promise<void> = async () => {
      config.value = await ASSISTANT_SERVICE.configWithDefaults();
      HTTP_CLIENT.updateConfig({ timeout: config.value.requestTimeoutInSeconds * 1000 });
      EXTERNAL_REQUEST_HTTP_CLIENT.updateConfig({
        timeout: config.value.requestTimeoutInSeconds * 1000,
      });
      HTTP_CLIENT_NLS.updateConfig({ timeout: config.value.requestTimeoutInSeconds * 1000 });
      if (config.value.customization.colors) {
        applyCustomColors(config.value.customization.colors);
      }
      if (config.value.customization.fonts) {
        applyCustomFontSettings(config.value.customization.fonts);
      }
      if (config.value.hasError) {
        addErrorNotification(t('CONFIG.error'), {
          label: t('SNACKBAR.refresh-page'),
          callback: () => {
            window.location.reload();
          },
        });
      }
    };

    return {
      config,
      getConfig,
    };
  },
  {
    persist: {
      pick: ['config'],
    },
  }
);
